@use 'subnavigation-vars';

:host {
  @include subnavigation-vars.wb-subnavigation-horizontal-vars;

  display: flex;
  align-items: center;
  gap: var(--subnavigation-items-gap);
  background-color: var(--subnavigation-background-color);
  border-radius: var(--subnavigation-border-radius);
}

:host([direction='vertical']) {
  @include subnavigation-vars.wb-subnavigation-vertical-vars;

  flex-direction: column;
  align-items: start;
}
